import {
    Tooltip,
    Center,
    Icon,
    Image,
} from '@chakra-ui/react';
import React from 'react';
import { TbAlertTriangle, TbCheck, TbFlag, TbX } from 'react-icons/tb';
import YaxleLogo from '../assets/yaxleLogoBlue.png';
import { brandCopy } from '../constants/brand';

const YaxleSelectionMark = React.forwardRef<HTMLDivElement>((props, ref) => (
    <Center
        ref={ref}
        w="22px"
        h="22px"
        minW="22px"
        minH="22px"
        borderRadius="full"
        border="1px solid"
        borderColor="brand.solid"
        display="inline-flex"
        flexShrink={0}
        {...props}
    >
        <Image src={YaxleLogo} w="14px" h="14px" objectFit="contain" alt="" />
    </Center>
));
YaxleSelectionMark.displayName = 'YaxleSelectionMark';

interface SelectionStatusIconProps {
    status: string;
    flagReason?: string | null;
}

const SelectionStatusIcon = ({ status, flagReason }: SelectionStatusIconProps) => {
    switch (status) {
        case 'manual':
            return (
                <Tooltip
                    label="Manually confirmed"
                    placement="top"
                    hasArrow
                >
                    <Center
                        w="22px"
                        h="22px"
                        minW="22px"
                        minH="22px"
                        borderRadius="full"
                        border="1px solid"
                        borderColor="orange.500"
                        display="inline-flex"
                        flexShrink={0}
                    >
                        <Icon
                            as={TbAlertTriangle as React.ElementType}
                            w={3.5}
                            h={3.5}
                            color="orange.500"
                        />
                    </Center>
                </Tooltip>
            );
        case 'flagged':
            return (
                <Tooltip
                    label={flagReason || "Part is flagged"}
                    placement="top"
                    hasArrow
                >
                    <Center
                        w="22px"
                        h="22px"
                        minW="22px"
                        minH="22px"
                        borderRadius="full"
                        border="1px solid"
                        borderColor="red.500"
                        display="inline-flex"
                        flexShrink={0}
                    >
                        <Icon
                            as={TbFlag as React.ElementType}
                            w={3.5}
                            h={3.5}
                            color="red.500"
                        />
                    </Center>
                </Tooltip>
            );
        case 'excluded':
            return (
                <Tooltip
                    label="Excluded"
                    placement="top"
                    hasArrow
                >
                    <Center
                        w="22px"
                        h="22px"
                        minW="22px"
                        minH="22px"
                        borderRadius="full"
                        border="1px solid"
                        borderColor="red.500"
                        display="inline-flex"
                        flexShrink={0}
                    >
                        <Icon
                            as={TbX as React.ElementType}
                            w={3.5}
                            h={3.5}
                            color="red.500"
                        />
                    </Center>
                </Tooltip>
            );
        case 'ordered':
            return (
                <Tooltip
                    label="Ordered"
                    placement="top"
                    hasArrow
                >
                    <Center
                        w="22px"
                        h="22px"
                        minW="22px"
                        minH="22px"
                        borderRadius="full"
                        border="1px solid"
                        borderColor="green.500"
                        display="inline-flex"
                        flexShrink={0}
                    >
                        <Icon
                            as={TbCheck as React.ElementType}
                            w={3.5}
                            h={3.5}
                            color="green.500"
                        />
                    </Center>
                </Tooltip>
            );
        case 'partbay':
            return (
                <Tooltip
                    label={brandCopy('Selected by PartBay')}
                    placement="top"
                    hasArrow
                >
                    <YaxleSelectionMark />
                </Tooltip>
            );
        default:
            return <YaxleSelectionMark />;
    }
};

export default SelectionStatusIcon;

